import { PermissionName } from '@vetahealth/fishing-gear/permissions'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Roles as RoleManagementComponent } from '../../components/Widgets/RoleManagement'
import { useUserStore } from '../../stores/user'
import { routes } from '.'
import { GenericWrapper } from './styles'

export function RoleManagement(): React.ReactNode {
  const navigate = useNavigate()
  const [hasPermission] = useUserStore((state) => [state.hasPermission])

  useEffect(() => {
    if (!hasPermission(PermissionName.manageRole)) {
      navigate(routes.patientList(), { replace: true })
      return
    }
  }, [])

  return (
    <GenericWrapper>
      <RoleManagementComponent />
    </GenericWrapper>
  )
}
